import {
  GetSimListSimAutoRenew,
  GetSimListSimStatusItem,
  GetSimListSimTypeItem,
  GetSimListSimVoiceOption,
} from "@/services/model";

/**
 * List of additional columns that can be filtered/displayed in the device list.
 */
export const additionalColumns = [
  "roamingDataConsumption",
  "roamingOpenRuntime",
  "roamingStatus",
  "telephoneNumber",
  "iccid",
] as const;

/**
 * Type representing the additional columns as an array of the allowed values.
 */
export type AdditionalColumnsEnum = (typeof additionalColumns)[number];

/**
 * Mapping type for additional columns visibility state.
 */
export type AdditionalColumnMap = {
  [key in AdditionalColumnsEnum]?: boolean;
};

/**
 * Form state for the device list filter dialog.
 */
export type FilterDialogForm = {
  /** Selected SIM types */
  simType: GetSimListSimTypeItem[];
  /** SIM auto-renew filter state */
  simAutoRenew: GetSimListSimAutoRenew | "ALL";
  /** SIM voice option filter state */
  simVoiceOption: GetSimListSimVoiceOption | "ALL";
  /** Selected SIM statuses */
  simStatus: GetSimListSimStatusItem[];
  /** List of selected additional columns to display */
  additionalColumns: AdditionalColumnsEnum[];
};
